import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';


export class SkyFilterButtonComponent {
  
  public active: boolean = false;

  
  public filterButtonClick: EventEmitter<any> = new EventEmitter();

  public filterButtonOnClick() {
    this.filterButtonClick.emit(undefined);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-button',
  styles: [`.sky-filter-btn-active, .sky-filter-btn-active:hover, .sky-filter-btn-active:focus {
  color: #71bf43;
  border: 2px solid #71bf43;
  padding: 5px 11px;
  /* offset the thicker border to avoid button size change */
}

.sky-filter-btn-active:hover, .sky-filter-btn-active:focus {
  color: #282b31;
}
`],
  template: `<button
  [attr.title]="'filter_button_title' | skyResources"
  [ngClass]="{'sky-filter-btn-active sky-rounded-corners': active}"
  type="button"
  class="sky-btn sky-btn-default sky-filter-btn"
  (click)="filterButtonOnClick()">
  <i class="fa fa-lg fa-filter"></i>
</button>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'active': [{ type: Input },],
'filterButtonClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
